import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=316f21ee&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports